module.exports = __webpack_public_path__ + "media/images/elionline/icons/da_assegnare_allenamento_facilitato-e7d274ebc37d4b979a99c57b6e706e79.svg";